/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { Form, Formik } from "formik";
import FormField from "layouts/pages/users/new-user/components/FormField";
import { errorAlert, successAlert } from "utils/Functions";
import { postNoResponse } from "utils/WebService";
import * as Yup from "yup";

export const passwordRequirements = [
  "Um caractere especial",
  "Uma letra maiúscula",
  "Mínimo de 6 caracteres",
  "Um número (2 são recomendados)"
];

export default function ChangePassword() {
  const { newPassword, newPasswordConfirmation } = changePasswordForm.formField


  const renderPasswordRequirements = passwordRequirements.map((item, key) => {
    const itemKey = `element-${key}`;

    return (
      <MDBox key={itemKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
        <MDTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
          {item}
        </MDTypography>
      </MDBox>
    );
  });

  const changePassword = (values, actions) => {
    const { newPassword } = values;
    actions.setSubmitting(true);
    const hide = () => {
      actions.setTouched({});
      actions.resetForm();
      actions.setSubmitting(false);
    }
    postNoResponse("/users/change-password", { password: newPassword })
      .then(() => successAlert("Senha alterada com sucesso!", hide))
      .catch(() => errorAlert("Algo de errado aconteceu! Tente novamente em breve.", hide));

  }

  return (
    <Card id="change-password">
      <MDBox p={3}>
        <MDTypography variant="h5">Alterar Senha</MDTypography>
      </MDBox>
      <Formik
        initialValues={{
          newPassword: "",
          newPasswordConfirmation: "",
        }}
        validationSchema={changePasswordValidations}
        onSubmit={changePassword}>
        {({ values, errors, touched, isSubmitting }) => {
          const {
            newPassword: newPasswordV,
            newPasswordConfirmation: newPasswordConfirmationV,
          } = values;
          return (
            <Form id={changePasswordForm.formId} autoComplete="off">
              <MDBox pb={3} px={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <FormField
                      fullWidth
                      type={newPassword.type}
                      label={newPassword.label}
                      name={newPassword.name}
                      value={newPasswordV}
                      placeholder={newPassword.placeholder}
                      error={errors.newPassword && touched.newPassword}
                      success={newPasswordV.length > 0 && !errors.newPassword}
                      inputProps={{ autoComplete: "" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormField
                      fullWidth
                      type={newPasswordConfirmation.type}
                      label={newPasswordConfirmation.label}
                      name={newPasswordConfirmation.name}
                      value={newPasswordConfirmationV}
                      placeholder={newPasswordConfirmation.placeholder}
                      error={errors.newPasswordConfirmation && touched.newPasswordConfirmation}
                      success={newPasswordConfirmationV.length > 0 && !errors.newPasswordConfirmation}
                      inputProps={{ autoComplete: "" }}
                    />
                  </Grid>
                </Grid>
                <MDBox mt={2} mb={1}>
                  <MDTypography variant="h5">Requerimentos da Senha</MDTypography>
                </MDBox>
                <MDBox display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap">
                  <MDBox component="ul" m={0} pl={3.25} mb={{ xs: 8, sm: 0 }}>
                    {renderPasswordRequirements}
                  </MDBox>
                  <MDBox ml="auto">
                    <MDButton
                      variant="contained"
                      color="info"
                      size="medium"
                      disabled={isSubmitting}
                      type="submit">
                      Alterar senha
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Form>)
        }}
      </Formik>
    </Card >
  );
}

export const changePasswordForm = {
  formId: "change-password-form",
  formField: {
    newPassword: {
      name: "newPassword",
      label: "Nova Senha",
      type: "password",
      errorMsg: "Campo Obrigatório.",
    },
    newPasswordConfirmation: {
      name: "newPasswordConfirmation",
      label: "Confirmação de Nova Senha",
      type: "password",
      errorMsg: "Campo Obrigatório.",
    },
  }
}

const {
  formField: { newPassword, newPasswordConfirmation },
} = changePasswordForm;

export const changePasswordValidations = Yup.object().shape({
  [newPassword.name]: Yup.string().required(newPassword.errorMsg)
    .min(6, 'Mínimo de 6 caracteres')
    .matches(/[A-Z]/, 'Uma letra maiúscula')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Um caractere especial')
    .matches(/\d/, 'Um número'),
  [newPasswordConfirmation.name]: Yup.string()
    .required(newPasswordConfirmation.errorMsg)
    .oneOf([Yup.ref("newPassword"), null], newPasswordConfirmation.errorMsg),
});

